// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__31EbN","containerItemsCenter":"Skeleton_containerItemsCenter__21Yuw"};